export const NAVBAR_MOBILE_HEIGHT = 64;
export const NAVBAR_DESKTOP_HEIGHT = 92;

export const pageSizes = [10, 25, 50, 100];
